import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http'
import { ADD, EDIT, VIEW } from '../../common/common';
import { getObjByName, deduplicationObjArr } from '../../common/utils';
import Add from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const Root = styled(Box)({
    '& .textField': {
        width: '100% !important',
        marginRight: '10px !important',
        backgroundColor: '#FFFFFF',
    },
    '& .delBtn': {
        cursor: 'pointer',
        '& .del': {
            color: '#9B9B9B',
        },
    },
})

class Participate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userList: [],
            userData: [],
        }
        this.handleSelect = this.handleSelect.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
    }
    render() {
        const {
            userList,
            userData,
        } = this.state;
        const { addBtnName } = this.props;

        const showDelBtn = (index) => {
            if (!this.isDisabled()) {
                return <div className="delBtn c" onClick={e => this.handleDelet(e, index)}>
                    <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
                </div>
            }
        }
        const showAddBtn = () => {
            if (!this.isDisabled()) {
                return <Button color="primary" onClick={this.handleAdd}>
                    <Add />{addBtnName}
                </Button>
            }
        }
        return (
            <Root>
                {userList.map((row, index) => (
                    <div className="h" key={index}>
                        <TextField
                            disabled={this.isDisabled()}
                            select
                            className="textField"
                            value={row.handler_id}
                            onChange={e => this.handleSelect(e, index)}
                            margin="dense"
                            variant="outlined"
                        >
                            {userData.map(option => (
                                <MenuItem key={option.id} value={option.id}>
                                    {/* {option.office ? option.office : "???"} - {this.teamName(option.teams)} - {option.first_name} {option.last_name} */}
                                    {option.first_name ? option.first_name : ""} {option.last_name ? option.last_name : ""} {option.email} {this.userDepts(option)}
                                </MenuItem>
                            ))}
                        </TextField>
                        {showDelBtn(index)}
                    </div>
                ))}
                {showAddBtn()}
            </Root>
        )
    }
    componentDidMount() {
        this.getUsers(() => {
            this.initData();
        });
    }
    initData() {
        const { state, userList } = this.props;
        console.log(userList)
        const srcDataClone = this.clone(userList);
        if (state === VIEW || state === EDIT || state === null) {
            if (userList) {
                this.setState(() => ({
                    userList: srcDataClone
                }))
            }
        }
    }
    handleSelect(e, index) {
        const { userData } = this.state;
        const value = e.target.value;
        const userObj = getObjByName(userData, "id", value);
        const teamObj = userObj.roles;
        let [...userList] = this.state.userList;
        let obj = userList[index];
        obj.handler_id = userObj.id;
        obj.handler_team_id = (teamObj && teamObj[0].team) ? teamObj[0].team.id : null;
        this.setState(() => ({
            userList
        }))
    }
    handleAdd() {
        let [...userList] = this.state.userList;
        let obj = {
            handler_id: "",
            handler_team_id: "",
            is_origin_attorney: false,
        }
        userList.push(obj);
        this.setState(() => ({
            userList
        }))
    }
    handleDelet(e, index) {
        let [...userList] = this.state.userList;
        userList.splice(index, 1);
        this.setState(() => ({
            userList
        }))
    }
    getData() {
        const { userList } = this.state;
        let arr = [];
        for (const obj of userList) {
            if (obj.handler_id !== "") {
                arr.push(obj);
            }
        }
        const newListData = deduplicationObjArr(arr, "handler_id");
        const srcData = this.props.userList;
        const addMembers = this.extMember(srcData, newListData);
        const delMembers = this.extMember(newListData, srcData);
        return { addMembers, delMembers };
    }
    extMember(list1, list2) {
        let result = [];
        for (const obj2 of list2) {
            let userId2 = obj2.handler_id;
            let isExist = false;
            for (const obj1 of list1) {
                let userId1 = obj1.handler_id;
                if (userId1 === userId2) {
                    isExist = true;
                    break;
                }
            }
            if (!isExist) {
                result.push(obj2);
            }
        }
        return result;
    }
    userDepts(userObj) {
        const roles = userObj.roles;
        if (!roles) return "";
        let deptStr = "";
        for (const obj of roles) {
            if (obj.team) {
                const office = obj.team.dept.office;
                const dept = obj.team.dept.name;
                const team = obj.team.name;
                const userDept = " [ " + office + " - " + dept + " - " + team + " ]";
                deptStr += userDept;
            }
        }
        return deptStr;
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        } else if (state === null) {
            return false;
        }
    }
    teamName(teams) {
        if (teams && teams.length > 0) {
            const dept = teams[0].dept.name;
            const team = teams[0].name;
            return dept + " - " + team;
        }
        return "???";
    }
    clone(origin) {
        return JSON.parse(JSON.stringify(origin))
    }
    //-----------request--------------
    getUsers(callback) {
        let params = {
            page_index: 1,
            page_size: 100
        }
        instance.get(BASE_URL + 'users', { params }).then((res) => {
            let userData = res.data.data
            console.log(userData)
            this.setState({
                userData
            }, () => {
                callback();
            });
        })
    }
}

export default Participate;